import React, { useState, useContext } from "react";
import { MapContext, MapActions } from "context/map";
import Dropdown from "components/Dropdown";
import RenameFarm from "components/Modal/RenameFarm";
import DeleteFarm from "components/Modal/DeleteFarm";
import ShareFarm from "components/Modal/ShareFarm";
import "./index.scss";

const MapOption = () => {
  const [renameFarm, setRenameFarm] = useState(false);
  const [deleteFarm, setDeleteFarm] = useState(false);
  const [shareFarm, setShareFarm] = useState(false);
  const { state, dispatch } = useContext(MapContext);
  const { mode, farm, exportMode } = state;
  const actions = [
    {
      id: "rename-farm",
      label: "Rename Farm",
      handleClick: () => {
        setRenameFarm(true);
      },
    },
    {
      id: "delete-farm",
      label: "Delete Farm",
      handleClick: () => {
        setDeleteFarm(true);
      },
    },
    {
      id: "invite-collaborator",
      label: "Invite Collaborator",
      handleClick: () => {
        setShareFarm(true);
      },
    },
    {
      id: "view-tutorial",
      label: "View Tutorial",
      handleClick: () => {
        dispatch({
          type: MapActions.SET_TUTORIAL_MODE,
          value: true,
        });
      },
    },
  ];

  return (
    <div className="map-options" style={exportMode ? { display: "none" } : {}}>
      <div id="geocoder" className="search" />
      {mode === "view" && <Dropdown iconOnly icon="more" data={actions} />}
      {farm && (
        <>
          <RenameFarm
            isOpen={renameFarm}
            farmInfo={farm.properties}
            onClose={() => setRenameFarm(false)}
          />
          <DeleteFarm
            isOpen={deleteFarm}
            farmInfo={farm.properties}
            redirectUrl="/farms"
            onClose={() => setDeleteFarm(false)}
          />
          <ShareFarm
            isOpen={shareFarm}
            selectedFarms={0}
            farm={farm}
            onClose={() => setShareFarm(false)}
          />
        </>
      )}
    </div>
  );
};

export default MapOption;
